import React from "react";
import { Button, Checkbox, DropdownButton, Flex } from "@jsq/ds/core";

interface FilterDropDownProps {
  label: string;
  options: string[];
  selectedOptions: string[];
  setSelectedOptions: (options: string[] | ((prev: string[]) => string[])) => void;
}

const FilterDropDown: React.FC<FilterDropDownProps> = ({
  label,
  options,
  selectedOptions,
  setSelectedOptions,
}) => {
  return (
    <DropdownButton label={label} keepOpen>
      <DropdownButton.Section name="">
        <Flex gap={8}>
          <Button
            variant="link"
            displayAsLink
            onClick={() => {
              setSelectedOptions(options);
            }}
          >
            Select All
          </Button>
          <Button
            variant="link"
            displayAsLink
            onClick={() => {
              setSelectedOptions([]);
            }}
          >
            None
          </Button>
          <Button
            variant="link"
            displayAsLink
            onClick={() => {
              setSelectedOptions((prev) => options.filter((option) => !prev.includes(option)));
            }}
          >
            Reverse
          </Button>
        </Flex>
      </DropdownButton.Section>
      {options.map((option) => (
        <DropdownButton.Action
          key={option}
          onSelect={() => {
            setSelectedOptions((prev) =>
              prev.includes(option)
                ? prev.filter((item) => item !== option)
                : [...prev, option],
            );
          }}
        >
          <Checkbox
            checked={selectedOptions.includes(option)}
            onChange={() => {
              /* Suppress RO warning */
            }}
            label={option}
          />
        </DropdownButton.Action>
      ))}
    </DropdownButton>
  );
};
export default FilterDropDown;
